import ProfileSetup from './ProfileSetup';

export default ProfileSetup; 